<template>

	<!-- Pagination -->
	<div class="pagination" v-if="paginationOptions !== undefined && paginationOptions.total">
		<ul class="pagination__list">
			<i class="pagination__btn_prev icon ion-ios-arrow-back" @click="previousPage"></i>

			<li class="pagination__item" v-for="page in paginationOptions.total" @click="selectPage(page)">
				<a class="pagination__link" :class="{' pagination__link_active': page == paginationOptions.current}">{{page}}</a>
			</li>

			<li class="pagination__item" v-show="paginationOptions.total > 3">
				<a class="pagination__link">...</a>
			</li>

			<li class="pagination__item" v-show="paginationOptions.total > 5">
				<a class="pagination__link">{{paginationOptions.total}}</a>
			</li>

			<i class="pagination__btn_next icon ion-ios-arrow-forward" @click="nextPage"></i>
		</ul>
	</div>
	<!-- Pagination End -->

</template>

<script>
	import _ from 'underscore'

	export default {
		name: "pagination",
		props: ['options'],
		computed: {
			paginationOptions() {
				return _.clone(this.options)
			}
		},
		methods: {
			previousPage() {
				if (this.paginationOptions.current < 2) return false
				--this.paginationOptions.current;
				this.$emit('trigger', this.paginationOptions.current)
			},
			nextPage() {
				if (this.paginationOptions.current >= this.paginationOptions.total) return false
				++this.paginationOptions.current;
				this.$emit('trigger', this.paginationOptions.current)
			},
			selectPage(page) {
				if (page !== this.paginationOptions.current) {
					this.$emit('trigger', page)
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Pagination.vue?7c10b86d